import { executeRequest, JFSRequest } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const updateMidPayoutConfigReq = (mid: any, data: any, tokens: any, isAdd: boolean, isBulk = false) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const reqBody = {
    entity: {
      initiatingEntityId: REACT_APP_CHANNEL_ID,
      entityId: mid,
    },
    payoutConfig: {
      frequencyId: isEmpty(data.frequencyId)
        ? undefined
        : !isNaN(data.frequencyId)
        ? Number(data.frequencyId)
        : data?.frequencyId,
      autoSettleDays: isEmpty(data?.autoSettleDays)
        ? undefined
        : !isNaN(data.autoSettleDays)
        ? Number(data.autoSettleDays)
        : data?.autoSettleDays,
      autoSettle: isEmpty(data.autoSettle)
        ? undefined
        : data.autoSettle === true || data.autoSettle === 'true'
        ? 1
        : data.autoSettle === false || data.autoSettle === 'false'
        ? 0
        : data.autoSettle,
      checker: isEmpty(data?.isDynamicSettlement)
        ? undefined
        : data?.isDynamicSettlement === true || data?.isDynamicSettlement === 'true'
        ? 1
        : data?.isDynamicSettlement === false || data?.isDynamicSettlement === 'false'
        ? 0
        : data?.isDynamicSettlement,
      payoutSettleHold: isEmpty(data?.settlementOnHold)
        ? undefined
        : data?.settlementOnHold === true || data?.settlementOnHold === 'true'
        ? 1
        : data?.settlementOnHold === false || data?.settlementOnHold === 'false'
        ? 0
        : data?.settlementOnHold,
      remarks: data?.remarks,
    },
    approvalDataType: 'PAYOUT_CONFIG',
  }
  const request: JFSRequest<{}> = {
    apiPath: isAdd
      ? isBulk
        ? getUrl(APIEndPoints.addBulkMidPayoutConfig)
        : getUrl(APIEndPoints.addMidPayoutConfig)
      : getUrl(APIEndPoints.updateMidPayoutConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: isBulk
      ? reqBody
      : {
          entity: {
            initiatingEntityId: REACT_APP_CHANNEL_ID,
            entityId: mid,
          },
          payoutConfig: {
            frequencyId: isEmpty(data.frequencyId)
              ? undefined
              : !isNaN(data.frequencyId)
              ? Number(data.frequencyId)
              : data?.frequencyId,
            autoSettleDays:
              isEmpty(data?.autoSettleDays) || data?.autoSettleDays === '0'
                ? undefined
                : !isNaN(data.autoSettleDays)
                ? Number(data.autoSettleDays)
                : data?.autoSettleDays,
            autoSettle: data?.autoSettle ? 1 : 0,
            checker: data?.isDynamicSettlement === true || data?.isDynamicSettlement === 'true' ? 1 : 0,
            payoutSettleHold: data?.settlementOnHold === true || data?.settlementOnHold === 'true' ? 1 : 0,
            remarks: data?.remarks ?? '',
          },
          approvalDataType: 'PAYOUT_CONFIG',
        },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateMidPayoutConfigReq }
